import { createBlock } from 'factories/block';
import { InteractionProps, repeat } from './interaction';
import { createLayout } from 'factories/layout';
import { colors } from 'styles/variables';
import { createMediaBlock } from './media';
import { Block, cloneBlock, Blocks } from '@chameleoncreator/creator-app';
import { flatten } from 'factories/utils';
import { createContinueBtn } from './continueBtn';
import { getSId } from '../utils';

const { lGrey0 } = colors;

let parsedFlipCardLayout;

export type FlipcardInteractionProps = InteractionProps & {
  answerCount: number;
};

export const createFlipcardsBlock = (count: number) => {
  requestAnimationFrame(() => (parsedFlipCardLayout = null));

  return createBlock('Flipcards', [
    ...repeat(
      () =>
        createBlock('Flipcard', [
          createMediaBlock({
            src: undefined,
            child: parsedFlipCardLayout[0],
            useBackgroundControls: false,
          }),
          createMediaBlock({
            src: undefined,
            child: parsedFlipCardLayout[1],
            useBackgroundControls: false,
          }),
        ]),
      count
    ),
  ]);
};

export const addFlipcard = (
  block: Block,
  position: number
): [Block, Blocks?] => {
  if (block.type === 'Flipcards') {
    const flipcardBlock = createBlock('Flipcard', [
      createMediaBlock({
        src: undefined,
        child: 1,
        useBackgroundControls: false,
      }),
      createMediaBlock({
        src: undefined,
        child: 0,
        useBackgroundControls: false,
        bulletColor: '#fff',
      }),
    ]);

    const flipcardBlockRef = { id: flipcardBlock.id, type: 'Ref' };
    const [newBlocks] = flatten(flipcardBlock);

    const nextBlock = cloneBlock(block);
    (nextBlock.children as Block[]).splice(position, 0, flipcardBlockRef);

    return [nextBlock, newBlocks];
  }
  return [block, undefined];
};

export const removeFlipcard = (
  block: Block,
  position: number
): [Block, Blocks?] => {
  if (block.type === 'Flipcards') {
    const flipcardBlock = createBlock('Flipcard', [
      createMediaBlock({
        src: undefined,
        child: 1,
        useBackgroundControls: false,
      }),
      createMediaBlock({
        src: undefined,
        child: 0,
        useBackgroundControls: false,
        bulletColor: '#fff',
      }),
    ]);

    const [newBlocks] = flatten(flipcardBlock);

    const nextBlock = cloneBlock(block);
    (nextBlock.children as Block[]).splice(position, 1);

    return [nextBlock, newBlocks];
  }
  return [block, undefined];
};

const contentForColumn = (count: number) => (i: number) => {
  return [() => createBlock('Text', []), () => createFlipcardsBlock(count)][i];
};

export const createFlipcardInteractionBlock = (
  props: FlipcardInteractionProps
) => {
  const {
    flipcardFrontColor = '#fff',
    flipcardBackColor = lGrey0,
    flipcardFrontTextColor = lGrey0,
    flipcardBackTextColor = '#fff',
    flipcardWidth = 300,
    flipcardHeight = 300,
    alignTextTop = 0,
    flipcardLayout,
    lockDown = 0,
    style,
  } = props as any;

  //
  // this is super dirty. so need to find the ' right ' way to get these props up there
  parsedFlipCardLayout = {
    imageText: [1, 0],
    imageImage: [1, 1],
    textText: [0, 0],
  }[flipcardLayout || 'imageText'];
  //
  //

  return createBlock(
    'Interaction',
    [
      createLayout(contentForColumn(props.answerCount), 0, true),
      createBlock('SingleColumnLayout', [
        createBlock('Column', [createContinueBtn(style)], {
          props: {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            flexWrap: 'wrap',
          },
          meta: {
            subType: 'ButtonBlock',
          },
        }),
      ]),
    ],
    {
      props: {
        name: props.name,
        sId: getSId('interaction'),
        style: props.style,
        flipcardFrontColor,
        flipcardBackColor,
        flipcardFrontTextColor,
        flipcardBackTextColor,
        flipcardWidth,
        flipcardHeight,
        alignTextTop,
        lockDown,
      },
      meta: {
        subType: 'FlipCard',
        layout: 'OneColumnReversed',
      },
    }
  );
};

export const create = createFlipcardInteractionBlock;
export const interactionConfig = {};
